import { AxiosResponse } from "axios";
import { BASE_URL, NAV_URL, httpClient } from "../config/develop-config";

const baseUrl = `${BASE_URL}/order-cart`;

const getFlashSaleList = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleById = async (flashSaleId: string) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/${flashSaleId}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleShopById = async (params: any) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/${params.flashSaleId}/shops`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleRound = async (params: any) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/rounds/${params.flashSaleId}/products`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleProductByRound = async (params: any) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/rounds/${params.flashSaleRoundId}/products`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleShopQuotaByRound = async (flashSaleRoundProductId: any) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/products/${flashSaleRoundProductId}/quota`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleRoundBadge = async (params: any) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/${params.flashSaleId}/rounds/quota-badge`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleHistory = async (flashSaleId: string) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/${flashSaleId}/history`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleNotification = async (flashSaleId: string) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/${flashSaleId}/notifications`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const createStepOne = async (params: any, file: File, fileMeno?: File, fileHighlight?: File) => {
  const formData = new FormData();
  formData.append("company", params.company);
  formData.append("flashSaleName", params.flashSaleName);
  formData.append("promotionCode", params.promotionCode);
  formData.append("productBrandId", params.productBrandId);
  formData.append("productBrandName", params.productBrandName);
  formData.append("cartLockTime", params.cartLockTime);
  formData.append("isFreeShip", params.isFreeShip);
  formData.append("isHighLight", params.isHighLight);
  formData.append("updateBy", params.updateBy);
  params.flashSaleId && formData.append("flashSaleId", params.flashSaleId);
  file && formData.append("coverImage", file);
  fileMeno && formData.append("refFile", fileMeno);
  fileHighlight && formData.append("highLightImage", fileHighlight);

  return await httpClient
    .post(`${baseUrl}/flash-sale/general-info`, formData)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const createStepTwo = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/flash-sale/schedule`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const createStepThree = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/flash-sale/shops`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const createStepFour = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/flash-sale/products`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const createStepFive = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/flash-sale/submit`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

const checkAvailableShop = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/available-shops`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const deleteFlashSale = async (params: any) => {
  return await httpClient
    .delete(`${baseUrl}/flash-sale/${params.flashSaleId}`, {
      params,
    })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const deleteProductFlashSale = async ({ flashSaleRoundProductIds, updatedBy }: any) => {
  const params = {
    flashSaleRoundProductIds: flashSaleRoundProductIds,
    updatedBy: updatedBy,
  };
  return await httpClient
    .delete(`${baseUrl}/flash-sale/products`, { data: params })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const approveFlashSale = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/flash-sale/enabled`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

const updateNotiPreview = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/flash-sale/notifications/preview`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const updateNotiCountdown = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/flash-sale/notifications/countdown`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const updateNotiRound = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/flash-sale/notifications/rounds`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

//#region Tracking Flash Sale
const getFlashSaleTracking = async (flashSaleId: string) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/${flashSaleId}/tracking`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const flashSaleSSELiveUrl = (flashSaleId: string) => {
  const searchParams = new URLSearchParams();
  searchParams.append("flashSaleId", flashSaleId);
  return `${baseUrl}/flash-sale/${flashSaleId}/tracking/live?${searchParams.toString()}`;
};
const getFlashSaleTrackingCart = async (params: any) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/rounds/${params.flashSaleRoundId}/tracking/cart-shops`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleTrackingRound = async (params: any) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/${params.flashSaleId}/tracking/detail`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleTrackingRoundShop = async (params: any) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/${params.flashSaleId}/tracking/shops`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleTrackingRoundOrder = async (params: any) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/${params.flashSaleId}/tracking/orders`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getFlashSaleTrackingRoundEachShop = async (params: any) => {
  return await httpClient
    .get(
      `${baseUrl}/flash-sale/${params.flashSaleId}/tracking/each-shops/${params.customerCompanyId}`,
      { params },
    )
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
//#endregion

const exportFlashSale = async (flashSaleId: any) => {
  const params = { flashSaleId };
  return await httpClient
    .post(`${baseUrl}/flash-sale/${flashSaleId}/export-excel`, params, {
      responseType: "arraybuffer",
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getShopListByFlashSaleId = async (flashSaleId: object) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/${flashSaleId}/shop-ids`, { params: { flashSaleId } })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const checkAvailableCode = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/flash-sale/check-promotion-code`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

export {
  getShopListByFlashSaleId,
  getFlashSaleList,
  getFlashSaleById,
  getFlashSaleShopById,
  getFlashSaleRound,
  getFlashSaleProductByRound,
  getFlashSaleShopQuotaByRound,
  getFlashSaleRoundBadge,
  getFlashSaleHistory,
  getFlashSaleNotification,
  createStepOne,
  createStepTwo,
  createStepThree,
  createStepFour,
  createStepFive,
  checkAvailableShop,
  deleteFlashSale,
  deleteProductFlashSale,
  approveFlashSale,
  updateNotiPreview,
  updateNotiCountdown,
  updateNotiRound,
  getFlashSaleTracking,
  flashSaleSSELiveUrl,
  getFlashSaleTrackingCart,
  getFlashSaleTrackingRound,
  getFlashSaleTrackingRoundShop,
  getFlashSaleTrackingRoundOrder,
  getFlashSaleTrackingRoundEachShop,
  exportFlashSale,
  checkAvailableCode,
};
